import { publicRequest } from "@/services";
import { Card, Flex, Form, Input, message, Typography } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { UserOutlined } from "@ant-design/icons";
import { SubmitButton } from "@/components/button/submit-button";
import useWebSocket, { ReadyState } from "react-use-websocket";
import { useNavigate } from "react-router-dom";
import { WS_URL } from "@/env";

const onRequestGetQR = async (email: string, callback: ()=> void) => {
  try {
    const result = await publicRequest<any, any>({
      url: `/qr?email=${email}`,
      method: "GET",
    });

    return result.data;
  } catch (error) {
    console.log(error);
    callback();
  }
};

const LoginQRCode: React.FC = () => {
  const [socketUrl, setSocketUrl] = useState(WS_URL);

  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [image, setImage] = React.useState("");

  const { readyState, getWebSocket } = useWebSocket(socketUrl, {
    shouldReconnect: (closeEvent) => false,

    reconnectAttempts: 3,
    reconnectInterval: (attemptNumber) =>
      Math.min(Math.pow(2, attemptNumber) * 1000, 10000),
  });

  const onMessage = useCallback(
    async (mes: MessageEvent) => {
      console.log(mes);

      const result = JSON.parse(mes.data);

      if (result.data) {
        await localStorage.setItem("email", form.getFieldValue("email") ?? "");
        await localStorage.setItem("access_token", result.data ?? "");

        message.success("ログインしました。");

        navigate("/admin", { replace: true });
      }
    },
    [navigate]
  );

  const onerror = (error: Event) => {
    console.log(error);
  };

  useEffect(() => {
    if (readyState === ReadyState.OPEN) {
      console.log("OPEN CONNECTION!!!");
      console.log(getWebSocket());
      getWebSocket()!.onmessage = onMessage;
      getWebSocket()!.onerror = onerror;
    }
  }, [getWebSocket, onMessage, readyState]);

  const onFinish = () => {
    message.success("Submit success!");
  };

  const onFinishFailed = () => {
    message.error("Submit failed!");
  };

  const onGetQRCode = useCallback(() => {
    setSocketUrl(`${WS_URL}/${form.getFieldValue("email")}`);

    form
      .validateFields()
      .then(async () => {
        try {
          const result = await onRequestGetQR(form.getFieldValue("email"), ()=>{
            message.error("Email doesn't exit");
          });
          console.log(result);
          setImage(`data:image/png;charset=utf-8;base64,${result}`);
        } catch (error) {}
      })
      .catch(() => {
        onFinishFailed();
      });
  }, [form]);

  return (
    <Flex gap="middle" align="center" vertical>
      <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
        QR Code
      </Typography.Text>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          name="email"
          label="メールアドレス"
          rules={[
            { required: true, message: "メールアドレスを再入力してください" },
            { type: "email", message: "メールは無効です。" },
          ]}
        >
          <Input
            style={{ width: 360 }}
            size="large"
            type="email"
            placeholder="メールアドレスを入力してください。!"
            prefix={<UserOutlined />}
          />
        </Form.Item>
      </Form>
      {image && (
        <Card size="small">
          <img src={image} />
        </Card>
      )}
      <Form.Item>
        <SubmitButton
          onClick={onGetQRCode}
          styles={{ width: 360 }}
          form={form}
          title={"ログイン"}
        />
      </Form.Item>
    </Flex>
  );
};

export default LoginQRCode;
